import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import isEqual from 'is-equal';
import styles from './styles.module.scss';
import InfiniteScroll from 'react-infinite-scroller';
import TruncateWithTooltip from 'src/components/truncateWithTooltip';
import dateformat from 'dateformat';
import buildUrl from 'build-url-ts';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import _ from 'lodash';
import { localizedStrings } from 'src/localization/index.jsx';
class UserListView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }
  constructor(props){
    super(props);

    this.state = {
      page: this.props.current,
    }

    this._loadMoreUsers = this._loadMoreUsers.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedUser = this.localizedUserManagement.user_view;
  }

  componentDidMount() {
    this.handleUrlChange(this.props);
    this.props.fetchUserManagementUser(this.props.params.id)
  }

  componentWillReceiveProps(nextProps) {
    if(!isEqual(this.props.location.search, nextProps.location.search)){
      this.handleUrlChange(nextProps);
    }

    if (nextProps.params.id && nextProps.users && nextProps.users.length > 0) {
      var user = nextProps.users.find((item) => {
        return item.id === nextProps.params.id
      })
      if(typeof user === "undefined"){
        user = nextProps.user;
      }
    }

    if(!isEqual(this.props.user, nextProps.user) && nextProps.params.id) {
      this._handleUserClick(nextProps.user);
    }
  }

  handleUrlChange(props) {
    var query = props.location.query["query"] || ''
    this.props.fetchUserManagementList(0, query, 'users');
  }

  _handleUserClick(user) {
    this.props.fetchUserManagementUser(user.id);
    this.props.hideSettingsSideMenu();
    this.props.invalidateUserGroups();

    var queryParams={};
    var query = this.props.location.query["query"] || ''
    if (query) {
      queryParams['query'] = query;
    }

    var path = buildUrl(null, {
      path: `/settings/user-management/user/${user.id}`,
      queryParams: queryParams
    });

    this.props.navigate(path);

    this.props.fetchUserGroupsForUser(0, user.id);
  }

  _loadMoreUsers() {
    var totalPages = this.props.totalPages;
    var current = this.props.currentPage;

    if(this.props.loading){
      return false;
    }

    var query = this.props.location.query["query"] || '';
    this.props.fetchUserManagementList(current + 1, query, 'users');
  }

  render() {
    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.currentPage < this.props.totalPages}
        loadMore={() => { this._loadMoreUsers() }}
        useWindow={false}
      > 
        {this._renderUsers()}
      </InfiniteScroll>
      
    );
  }

    _renderUsers(){
      if((!this.props.users || this.props.users.length == 0) && this.props.loading) {
        return this._renderLoading();
      }

      var rows = Array();

      this.props.users.forEach((user, index) => {
        {user.entityType === "user" &&
          rows.push(
            <div onClick={() => { this._handleUserClick(user) }} className={cx(styles.userRow, { [styles.userRowSelected]: user.id === this.props.params.id && !this.props.showSettingsMenu })} key={user.id}>
             <div className={styles.name}>
             <TruncateWithTooltip
             lines={1}
             text={_.join(
             _.compact([
             _.get(user, 'firstName', ''),
             _.get(user, 'lastName', '')
             ]),
             ' '
             )}
             />
             </div>
              <div className={cx(styles.type,!this.props.showSettingsMenu && styles.typeRight)}>
                {this._getType(user)}
              </div>
              {this.props.showSettingsMenu &&
              <div className={styles.date}>
                {user.lastLoginDate ? `${this.localizedUser.last_access}:` + dateformat(user.lastLoginDate, 'dd mmm yyyy') : '' }
              </div>}
            </div>
          )
        }
      });
      
      return rows;
    }
    
    _getType(user) {
      if(!user.enabled){
        return this.localizedUser.types.deactivated;
      }

      if(user.enabled && user.accountNonLocked){
          return this.localizedUser.types.active;
      }

      if(user.enabled && !user.accountNonLocked){
          return this.localizedUser.types.account_locked;
      }
    }

    _renderLoading() {
      return (
        <div className={styles.loading}>
          <LoadingMessage
          className={styles.loadingInner}
          message={`${this.localizedCommonLoading.users}...`}
          visible={true} />
        </div>
      )
    }

}

UserListView.contextTypes = {
  store: PropTypes.object
}

export default UserListView;    
